import Card from './Card.vue';
import { ODLOZENE_SERVISNI_CINNOSTI } from './constants';

export const OdlozenaServisniCinnost = {
	name: ODLOZENE_SERVISNI_CINNOSTI,
	components: {
		Card,
	},
};
